import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الذائبية - احسب الذائبية في الماء";
const DESCRIPTION =
  "استخدم حاسبة الذائبية لحساب أقصى كمية من المادة التي يمكن إذابتها في الماء. اعرف الفرق بين المحاليل المشبعة وغير المشبعة.";
const KEYWORDS =
  "حاسبة الذائبية, الذائبية, محاليل مشبعة, محاليل غير مشبعة, كيمياء, حساب الذائبية, العلوم الكيميائية";
const OG_URL = "https://do-calculate.com/calculator/ar/solubility-calculator/";
function SolubilityCalculator() {
  const [firstValue, setFirstValue] = useState(0);
  const [secondValue, setSecondValue] = useState(0);
  const [result, setResult] = useState();
  const [steps, setSteps] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (firstValue && secondValue) {
        const solubility = (parseInt(firstValue) * 100) / parseInt(secondValue);
        setResult(solubility.toFixed(2));
        setSteps(`لحساب الذائبية:
        \n1. نقوم بضرب كتلة المادة المذابة في 100: ${firstValue} × 100 = ${
          firstValue * 100
        }
        \n2. نقسم الناتج على كتلة الماء (المادة المذيبة): ${
          firstValue * 100
        } ÷ ${secondValue} = ${solubility.toFixed(2)}`);
        setError("");
      } else {
        setError(
          "الرجاء إدخال جميع القيم المطلوبة من أجل القيام بالعملية الحسابية!"
        );
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بحساب الذائبية باستخدام المعادلة التالية:
                </p>
                <p>
                  <strong>
                    الذائبية = كتلة المادة المذابة * 100 / كتلة المادة المذيبة
                  </strong>
                </p>
                <ul>
                  <li>
                    ادخل كتلة المادة المذابة (الصلبة) التي ترغب في إذابتها.
                  </li>
                  <li>ادخل كتلة الماء المستخدم (المادة المذيبة).</li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة لتساعدك في فهم مدى قدرة مادة معينة على
                  الذوبان في الماء، مما يساعدك على تحديد نوع المحلول الناتج.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="firstValue">
                      <label className="form-label ms-2">
                        ادخل كتلة المادة المذابة (بالجرام)
                      </label>
                      <input
                        id="firstValue"
                        type="number"
                        value={firstValue}
                        onChange={(e) => setFirstValue(e.target.value)}
                        placeholder="أدخل كتلة المادة المذابة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="secondValue">
                      <label className="form-label ms-2">
                        ادخل كتلة الماء (بالجرام)
                      </label>
                      <input
                        id="secondValue"
                        type="number"
                        value={secondValue}
                        onChange={(e) => setSecondValue(e.target.value)}
                        placeholder="أدخل كتلة الماء"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">النتيجة:</h4>
                      <p className="text-white">{result}</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>خطوات الحل:</h4>
                        <p
                          className="text-black"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {steps}
                        </p>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>أنواع المحاليل</h2>{" "}
                  </u>
                  <p>
                    عند إذابة أي مادة صلبة في الماء، يمكن أن يتشكل نوعان من
                    المحاليل:
                  </p>
                  <ul>
                    <li>
                      <strong>محلول مشبع:</strong> هو المحلول الذي لا يمكن إذابة
                      المزيد من المادة الصلبة فيه دون تغيير درجة حرارته.
                    </li>
                    <li>
                      <strong>محلول غير مشبع:</strong> هو المحلول الذي يمكن
                      إذابة المزيد من المادة الصلبة فيه دون الحاجة إلى تغيير في
                      درجة الحرارة.
                    </li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      العوامل المؤثرة على الذائبية
                    </h2>{" "}
                  </u>
                  <p>تتأثر الذائبية بعدة عوامل منها:</p>
                  <ul>
                    <li>درجة الحرارة</li>
                    <li>طبيعة المادة المذابة والمذيبة</li>
                    <li>ضغط الغاز (في حالة المحاليل الغازية)</li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      أهمية الذائبية في الحياة اليومية
                    </h2>{" "}
                  </u>
                  <p>
                    تلعب الذائبية دوراً مهماً في العديد من العمليات الحيوية
                    والصناعية مثل:
                  </p>
                  <ul>
                    <li>إعداد المشروبات والعقاقير</li>
                    <li>معالجة المياه</li>
                    <li>الصناعات الكيميائية المختلفة</li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>{" "}
                  </u>
                  <p>
                    تجد هنا إجابات لبعض الأسئلة الشائعة حول الذائبية وكيفية
                    حسابها.
                  </p>
                  <b>كيف يمكنني زيادة ذائبية مادة في الماء؟</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    يمكنك زيادة الذائبية عن طريق تسخين الماء أو إضافة مذيب آخر.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default SolubilityCalculator;
